module.exports = __webpack_public_path__ + "img/dsn04.cc154046.gif";